export function loadSaleOrder(query, willReload) {
  return {
    type: 'LOAD_SALE_ORDER',
    query,
    willReload: !!query.time || willReload,
  };
}

export function loadSaleOrderCompletion(error, list) {
  return {
    type: 'LOAD_SALE_ORDER_COMPLETION',
    error,
    list,
  };
}
